

import {
    XTAREAS_PROYECTO,
    AGREGAR_XTAREA,
    VALIDAR_XTAREA,
    ELIMINAR_XTAREA,
    
    XTAREA_ACTUAL,
    ACTUALIZAR_XTAREA,
    LIMPIAR_XTAREA
} from '../../types';

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state, action) => {
    switch (action.type) {
        case XTAREAS_PROYECTO:
            return{
                ...state,
                xtareasproyecto: action.payload
            }
        case AGREGAR_XTAREA:
            return{
                ...state,
                xtareasproyecto: [...state.xtareasproyecto, action.payload],
                errorxtarea: false
            }
        case VALIDAR_XTAREA:
            return{
                ...state,
                errorxtarea: true
            }
        case ELIMINAR_XTAREA:
            return{
                ...state,
                xtareasproyecto: state.xtareasproyecto.filter(xtarea => xtarea._id !== action.payload)
            }
        case ACTUALIZAR_XTAREA:        
            return{
                ...state,
                xtareasproyecto: state.xtareasproyecto.map(xtarea => xtarea._id === action.payload._id ? action.payload : xtarea )
            }
        case XTAREA_ACTUAL:
            return{
                ...state,
                xtareaseleccionada: action.payload
            }
        case LIMPIAR_XTAREA:
            return{
                ...state,
                xtareaseleccionada: null
            }
        default:
            return state;
    }
}